/* "Start Customizing" picker -- see snippets/pp-customize-picker.liquid.
   2026-10-29 (Jesse): two steps only.
     Step 1 what: Engraved ID Tag goes straight to the ID tag collection.
     Step 2 who:  necklace -> Jewelry collection filtered for that pet (or for you);
                  harness  -> the cat / dog harness product page (size + color are picked there).
   The old step-3 code (pearl type / size / tag shape) is kept below but no longer used. */
(function () {
  var dialog = document.querySelector('[data-pp-picker]');
  var dataEl = document.querySelector('[data-pp-picker-data]');
  if (!dialog || !dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var body = dialog.querySelector('[data-pp-picker-body]');
  var titleEl = dialog.querySelector('[data-pp-picker-title]');
  var eyebrowEl = dialog.querySelector('[data-pp-picker-eyebrow]');
  var backBtn = dialog.querySelector('[data-pp-picker-back]');
  var foot = dialog.querySelector('[data-pp-picker-foot]');
  var goBtn = dialog.querySelector('[data-pp-picker-go]');
  var detailsLink = dialog.querySelector('[data-pp-picker-details]');
  var dots = dialog.querySelectorAll('.pp-picker-progress li');
  var opener = null;

  var TYPES = [
    { key: 'necklace', title: 'Pearl Necklace', text: 'Pearls with the charms you pick' },
    { key: 'harness', title: 'Harness Set', text: 'Patches, their name, matching leash' },
    { key: 'tag', title: 'Engraved ID Tag', text: 'Their name and your phone number' }
  ];
  var PETS = {
    cat: { title: 'My Cat', icon: 'cat' },
    dog: { title: 'My Dog', icon: 'dog' },
    me: { title: 'Me', text: 'A matching strand for you', icon: 'me' }
  };
  var ICONS = {
    cat: '<svg class="pp-picker-logo-pet pp-picker-logo-pet--cat" viewBox="0 0 100 100" aria-hidden="true"><path stroke-width="4.2" d="M26 75C16 66 14 50 20 39C19 30 20 20 24 13C30 17 35 22 39 28C46 25.5 54 25.5 61 28C65 22 70 17 76 13C80 20 81 30 80 39C86 50 84 66 74 75C67 81 58 84 50 84C43 84 37 82 32 79"/><circle class="pp-pet-eye" cx="39" cy="53" r="3.8" fill="currentColor" stroke="none"/><circle class="pp-pet-eye" cx="61" cy="53" r="3.8" fill="currentColor" stroke="none"/><path stroke-width="2.6" d="M48 62.5L50 64L52 62.5"/><path stroke-width="2.6" d="M21 61L30 63M22 67L30 66.5M25 72.5L31 69.5M79 61L70 63M78 67L70 66.5M75 72.5L69 69.5"/></svg>',
    dog: '<svg class="pp-picker-logo-pet pp-picker-logo-pet--dog" viewBox="0 0 100 100" aria-hidden="true"><path stroke-width="4.2" d="M33 29C40 23.5 60 23.5 67 29C74 36 76 48 74 61C72 74 62 84 50 84C38 84 28 74 26 61C24.5 50 26 39 31 32"/><path stroke-width="4.2" d="M33 29C24 24 14 31 13 44C12.5 53 17 58 23 54C25 52 26 49 26.5 46"/><path stroke-width="4.2" d="M67 29C70 20 80 15 86 20C91 25 88 36 80 37C74 37.5 72 31 76 27.5C79 25 83 27 83 30"/><circle class="pp-pet-eye" cx="40" cy="51" r="3.8" fill="currentColor" stroke="none"/><circle class="pp-pet-eye" cx="60" cy="51" r="3.8" fill="currentColor" stroke="none"/><ellipse cx="50" cy="64" rx="5.2" ry="4" fill="currentColor" stroke="none"/></svg>',
    me: '<svg class="pp-picker-logo-pet pp-picker-logo-pet--me" viewBox="0 0 100 100" aria-hidden="true"><g class="pp-pet-head"><path stroke-width="4.2" d="M37 33C37 44 41 55 50 55C59 55 63 44 63 33"/><path stroke-width="4.2" d="M30 60C27 50 27 38 30 28C34 17 43 12 52 13C63 14 70 22 71 33C72 43 71 52 68 60C66 64 62 64 61 61"/><path stroke-width="4.2" d="M37 33C44 31 50 26 52 18"/><circle class="pp-pet-eye" cx="44.5" cy="40" r="3.2" fill="currentColor" stroke="none"/><circle class="pp-pet-eye" cx="55.5" cy="40" r="3.2" fill="currentColor" stroke="none"/></g><path stroke-width="4.2" d="M45 55L45 62M55 55L55 62M18 92C20 76 30 66 44 64M82 92C80 76 70 66 56 64"/><g fill="currentColor" stroke="none"><circle cx="36.5" cy="70" r="2.7"/><circle cx="39.5" cy="75.3" r="2.7"/><circle cx="44.2" cy="79" r="2.7"/><circle cx="50" cy="80.3" r="2.7"/><circle cx="55.8" cy="79" r="2.7"/><circle cx="60.5" cy="75.3" r="2.7"/><circle cx="63.5" cy="70" r="2.7"/></g></svg>'
  };

  // Card image fallbacks: the ID tag card uses the first tag shape's photo.
  if (!data.images.tag) {
    var firstTag = ((data.tag || {}).dog || [])[0] || ((data.tag || {}).cat || [])[0];
    if (firstTag) data.images.tag = firstTag.image;
  }

  var state = {};
  var history = [];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function optionIndex(p, name) {
    var n = name.toLowerCase();
    for (var i = 0; i < (p.options || []).length; i++) if (String(p.options[i]).toLowerCase() === n) return i;
    return -1;
  }
  function uniqueValues(p, idx) {
    var out = [];
    p.variants.forEach(function (v) { var val = v.options[idx]; if (out.indexOf(val) === -1) out.push(val); });
    return out;
  }
  function hasRealVariants(p) { return p && p.variants && p.variants.length > 1; }

  function setHeader(step, title) {
    eyebrowEl.textContent = 'Step ' + step + ' of 2';
    titleEl.textContent = title;
    dots.forEach(function (d, i) { d.classList.toggle('is-done', i < step); });
    backBtn.hidden = step === 1;
  }

  function card(opts) {
    return '<button type="button" class="pp-picker-card' + (opts.selected ? ' is-selected' : '') + '" data-value="' + esc(opts.value) + '" aria-pressed="' + (opts.selected ? 'true' : 'false') + '"' + (opts.disabled ? ' disabled' : '') + '>' +
      (opts.image ? '<span class="pp-picker-card-img"><img src="' + esc(opts.image) + '" alt="" loading="lazy"></span>' : '') +
      (opts.icon ? '<span class="pp-picker-card-icon">' + ICONS[opts.icon] + '</span>' : '') +
      '<span class="pp-picker-card-text"><strong>' + esc(opts.title) + '</strong>' + (opts.text ? '<span>' + esc(opts.text) + '</span>' : '') + '</span></button>';
  }
  // labels: optional { value: display text }, e.g. "M" -> "M (12-14 in)" from cpb.size_label.
  function chips(label, values, selected, key, unavailable, labels) {
    return '<div class="pp-picker-group"><p class="pp-picker-label">' + esc(label) + '</p><div class="pp-picker-chips" data-key="' + key + '">' +
      values.map(function (v) {
        var off = unavailable && unavailable.indexOf(v) !== -1;
        var l = labels && labels[v];
        var text = !l ? v : (l.indexOf(v) === 0 ? l : v + ' · ' + l);
        return '<button type="button" class="pp-picker-chip' + (off ? ' is-unavailable' : '') + '" data-value="' + esc(v) + '" aria-pressed="' + (v === selected ? 'true' : 'false') + '">' + esc(text) + '</button>';
      }).join('') + '</div></div>';
  }
  function bindCards(fn) {
    body.querySelectorAll('.pp-picker-card').forEach(function (b) {
      b.addEventListener('click', function () { fn(b.getAttribute('data-value')); });
    });
  }
  function bindChips(fn) {
    body.querySelectorAll('.pp-picker-chips').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var b = e.target.closest('.pp-picker-chip');
        if (!b || b.classList.contains('is-unavailable')) return;
        fn(group.getAttribute('data-key'), b.getAttribute('data-value'));
      });
    });
  }
  function go(step) { history.push(step); render(); }

  /* ---- Step 1: what ---- */
  function stepType() {
    setHeader(1, 'What are we making?');
    body.innerHTML = '<div class="pp-picker-cards pp-picker-cards--3">' + TYPES.map(function (t) {
      return card({ value: t.key, title: t.title, text: t.text, image: data.images[t.key], selected: state.type === t.key });
    }).join('') + '</div>';
    bindCards(function (v) {
      if (state.type !== v) state = { type: v };
      if (v === 'tag') { window.location.href = data.tagCollectionUrl || '/collections/engraved-id-tags'; return; }
      go('pet');
    });
    foot.hidden = true;
  }

  /* ---- Step 2: who ---- */
  function stepPet() {
    setHeader(2, 'Who is it for?');
    var pets = state.type === 'necklace' ? ['cat', 'dog', 'me'] : ['cat', 'dog'];
    body.innerHTML = '<div class="pp-picker-cards pp-picker-cards--' + pets.length + '">' + pets.map(function (k) {
      return card({ value: k, title: PETS[k].title, text: PETS[k].text, icon: PETS[k].icon, selected: state.pet === k });
    }).join('') + '</div>';
    bindCards(function (v) {
      if (state.pet !== v) { state = { type: state.type, pet: v }; }
      var url = null;
      if (state.type === 'necklace') {
        url = (data.jewelryUrl || '/collections/jewelry') + '?for=' + ({ cat: 'cats', dog: 'dogs', me: 'you' })[v];
      } else if (state.type === 'harness') {
        var hp = (data.harness || {})[v];
        url = hp && hp.url;
      }
      if (url) { window.location.href = url; return; }
      go('details');
    });
    foot.hidden = true;
  }

  /* ---- Step 3: details ---- */
  function stepDetails() {
    var t = state.type, pet = state.pet;
    if (t === 'necklace') return detailsNecklace(pet);
    if (t === 'harness') return detailsHarness(pet);
    return detailsTag(pet);
  }

  function detailsNecklace(pet) {
    setHeader(3, pet === 'me' ? 'Choose your pearls' : 'Choose their pearls');
    var set = (data.necklace || {})[pet] || {};
    var kinds = [
      { key: 'freshwater', title: 'Freshwater Pearls', text: 'Genuine pearls imported from Japan' },
      { key: 'faux', title: 'Faux Pearls', text: 'The classic look at a friendlier price' }
    ].filter(function (k) { return set[k.key]; });
    if (!state.pearl && kinds.length === 1) state.pearl = kinds[0].key;
    var html = '<div class="pp-picker-cards pp-picker-cards--2 pp-picker-cards--row">' + kinds.map(function (k) {
      var p = set[k.key];
      return card({ value: k.key, title: k.title, text: (p.priceVaries ? 'From ' : '') + p.price + ' · ' + k.text, image: p.image, selected: state.pearl === k.key });
    }).join('') + '</div>';
    var product = state.pearl ? set[state.pearl] : null;
    if (product && hasRealVariants(product)) {
      var si = Math.max(0, optionIndex(product, 'size'));
      var sizes = uniqueValues(product, si);
      var unavailable = product.variants.filter(function (v) { return !v.available; }).map(function (v) { return v.options[si]; });
      var sizeLabels = {};
      product.variants.forEach(function (v) { if (v.label) sizeLabels[v.options[si]] = v.label; });
      html += chips('Size', sizes, state.size, 'size', unavailable, sizeLabels);
      html += '<p class="pp-picker-hint">Measure around the neck where the necklace will sit. Unsure? Check the size guide on the next page.</p>';
    } else if (product) {
      html += '<p class="pp-picker-hint">' + (pet === 'cat' ? 'Breakaway clasp, one size — no measuring needed.' : 'One size.') + '</p>';
    }
    body.innerHTML = html;
    bindCards(function (v) { state.pearl = v; state.size = null; render(); });
    bindChips(function (key, v) { state[key] = v; render(); });

    var variant = null;
    if (product) {
      if (!hasRealVariants(product)) variant = product.variants[0];
      else if (state.size) {
        var idx = Math.max(0, optionIndex(product, 'size'));
        variant = product.variants.filter(function (v) { return v.options[idx] === state.size; })[0] || null;
      }
    }
    finish(product, variant, product && hasRealVariants(product) && !state.size ? 'Pick a size to continue' : (variant && variant.available === false ? 'Sold out -- pick another size' : null));
  }

  function detailsHarness(pet) {
    setHeader(3, 'Pick size and color');
    var product = (data.harness || {})[pet];
    if (!product) { body.innerHTML = '<p class="pp-picker-hint">Coming soon.</p>'; foot.hidden = true; return; }
    var si = optionIndex(product, 'size'), ci = optionIndex(product, 'color');
    var html = '';
    if (si !== -1) html += chips('Size', uniqueValues(product, si), state.size, 'size');
    if (ci !== -1) html += chips('Color', uniqueValues(product, ci), state.color, 'color');
    html += '<p class="pp-picker-hint">Between sizes? Check the size guide on the next page before you customize.</p>';
    body.innerHTML = html;
    bindChips(function (key, v) { state[key] = v; render(); });
    var variant = product.variants.filter(function (v) {
      return (si === -1 || v.options[si] === state.size) && (ci === -1 || v.options[ci] === state.color);
    })[0];
    var ready = (si === -1 || state.size) && (ci === -1 || state.color);
    finish(product, ready ? variant : null, !ready ? 'Pick a size and color to continue' : (!variant ? 'Not available -- pick another size or color' : (variant.available === false ? 'Sold out -- pick another size or color' : null)));
  }

  function detailsTag(pet) {
    setHeader(3, 'Choose a tag shape');
    var tags = ((data.tag || {})[pet] || []).filter(Boolean);
    body.innerHTML = '<div class="pp-picker-cards pp-picker-cards--tags" style="--cols: ' + Math.min(Math.max(tags.length, 2), 4) + '">' + tags.map(function (p) {
      return card({ value: p.handle, title: p.title.replace(/\s*(Engraved\s+)?ID Tag$/i, ''), text: (p.priceVaries ? 'From ' : '') + p.price, image: p.image, selected: state.tag === p.handle });
    }).join('') + '</div><p class="pp-picker-hint">You\'ll choose the finish and add their name in the customizer.</p>';
    bindCards(function (v) { state.tag = v; render(); });
    var product = tags.filter(function (p) { return p.handle === state.tag; })[0] || null;
    finish(product, product ? product.variants[0] : null, product ? null : 'Pick a shape to continue', true);
  }

  function finish(product, variant, blockedMsg, noVariantParam) {
    foot.hidden = false;
    if (product && variant && !blockedMsg) {
      var base = product.url + (noVariantParam ? '?' : '?variant=' + variant.id + '&');
      goBtn.href = base + 'customize=1';
      goBtn.removeAttribute('aria-disabled');
      goBtn.textContent = 'Start Customizing';
      detailsLink.href = noVariantParam ? product.url : product.url + '?variant=' + variant.id;
      detailsLink.hidden = false;
      detailsLink.textContent = noVariantParam ? 'View details first' : 'View details & size guide first';
    } else {
      goBtn.removeAttribute('href');
      goBtn.setAttribute('aria-disabled', 'true');
      goBtn.textContent = blockedMsg || 'Start Customizing';
      detailsLink.hidden = true;
    }
  }

  function render() {
    var step = history[history.length - 1] || 'type';
    if (step === 'type') stepType();
    else if (step === 'pet') stepPet();
    else stepDetails();
  }

  function open(e) {
    if (e) e.preventDefault();
    opener = e && e.currentTarget;
    state = {};
    history = ['type'];
    render();
    if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
    document.documentElement.classList.add('pp-picker-open');
  }
  function close() {
    if (dialog.close) dialog.close(); else dialog.removeAttribute('open');
  }
  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('pp-picker-open');
    if (opener && opener.focus) opener.focus();
  });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
  dialog.querySelector('[data-pp-picker-close]').addEventListener('click', close);
  backBtn.addEventListener('click', function () { if (history.length > 1) { history.pop(); render(); } });
  goBtn.addEventListener('click', function (e) { if (goBtn.getAttribute('aria-disabled') === 'true') e.preventDefault(); });

  document.querySelectorAll('[data-pp-picker-open]').forEach(function (el) { el.addEventListener('click', open); });
})();
